// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: 400,
        },
        outlined: {
          backgroundColor: theme.palette.primary.lighter,
          borderColor: `${theme.palette.primary.main}`,
          color: theme.palette.primary.darker,
          "&:hover": {
            backgroundColor: theme.palette.primary[100],
          },
        },
      },
      variants: [
        {
          props: {  variant:"outlined" },
          style: ({theme,ownerState})=> (  {
            color: theme.palette[ownerState?.color || "primary"].dark,
            backgroundColor: theme.palette[ownerState?.color || "primary"].lighter,
            borderColor: `${theme.palette[ownerState?.color || "primary"].main}`,
            "&:hover": {
              backgroundColor: theme.palette[ownerState?.color || "primary"][100],
            },
          }),
        },
      ],
    },
  };
}
